import { AudioFile } from '../types';
import { loadOtherAudios } from '../utils/loadOtherAudios';

// 音訊分類
export const categories = [
  { id: 'noise', name: '白噪音' },
  { id: 'nature', name: '自然聲音' },
  { id: 'ambient', name: '環境聲音' },
  { id: 'music', name: '音樂' },
  { id: 'binaural', name: '雙耳節拍' },
  { id: 'isochronic', name: '等時節拍' },
  { id: 'custom', name: '自定義' },
  { id: 'other', name: '其他' }
];

// 動態加載其他分類的音訊檔案
let otherAudioFiles: AudioFile[] = [];

// 加載其他音訊檔案的函數
export const loadAllOtherAudios = async (): Promise<void> => {
  otherAudioFiles = await loadOtherAudios();
};

// 音訊檔案與分類對應
export const getAudioFiles = (): AudioFile[] => {
  // 合并预定义的音频文件和动态加载的其他音频文件
  return [...staticAudioFiles, ...otherAudioFiles];
};

// 预定义的音频文件
export const staticAudioFiles: AudioFile[] = [
  // 白噪音
  { name: "白噪音", path: "/audio/WhiteNoise.m4a", category: "noise" },
  { name: "粉紅噪音", path: "/audio/PinkNoise.m4a", category: "noise" },
  { name: "棕色噪音", path: "/audio/BrownNoise.m4a", category: "noise" },
  
  // 自然聲音
  { name: "雨聲", path: "/audio/Rain.m4a", category: "nature" },
  { name: "輕雨", path: "/audio/LightRain.m4a", category: "nature" },
  { name: "大雨", path: "/audio/HeavyRain.m4a", category: "nature" },
  { name: "雨暴", path: "/audio/Rainstorm.m4a", category: "nature" },
  { name: "雨天", path: "/audio/RainyDay.m4a", category: "nature" },
  { name: "屋頂雨聲", path: "/audio/RainonRoof.m4a", category: "nature" },
  { name: "帳篷雨聲", path: "/audio/RainonTent.m4a", category: "nature" },
  { name: "城市雨聲", path: "/audio/UrbanRain.m4a", category: "nature" },
  { name: "森林雨聲", path: "/audio/ForestRain.m4a", category: "nature" },
  { name: "雷聲", path: "/audio/Thunder.m4a", category: "nature" },
  { name: "雷暴", path: "/audio/Thunderstorm.m4a", category: "nature" },
  { name: "海洋", path: "/audio/Ocean.m4a", category: "nature" },
  { name: "海邊", path: "/audio/Seaside.m4a", category: "nature" },
  { name: "河流", path: "/audio/River.m4a", category: "nature" },
  { name: "水拍岸", path: "/audio/LappingWater.m4a", category: "nature" },
  { name: "瀑布", path: "/audio/Waterfall.m4a", category: "nature" },
  { name: "鳥鳴", path: "/audio/Birds.m4a", category: "nature" },
  { name: "蟋蟀", path: "/audio/Cicadas.m4a", category: "nature" },
  { name: "青蛙", path: "/audio/Frogs.m4a", category: "nature" },
  { name: "貓頭鷹", path: "/audio/Owls.m4a", category: "nature" },
  { name: "海鷗", path: "/audio/Seagulls.m4a", category: "nature" },
  { name: "鳴禽", path: "/audio/Peepers.m4a", category: "nature" },
  { name: "狼嚎", path: "/audio/Wolf.m4a", category: "nature" },
  { name: "鯨魚", path: "/audio/Whales.m4a", category: "nature" },
  { name: "鯨魚 2", path: "/audio/Whales2.m4a", category: "nature" },
  { name: "風聲", path: "/audio/Winds.m4a", category: "nature" },
  { name: "風吹樹", path: "/audio/WindInTrees.m4a", category: "nature" },
  { name: "風湧", path: "/audio/WindSurge.m4a", category: "nature" },
  { name: "風鈴", path: "/audio/WindChimes.m4a", category: "nature" },
  { name: "樹葉沙沙聲", path: "/audio/RustlingLeaves.m4a", category: "nature" },
  { name: "篝火", path: "/audio/Campfire.m4a", category: "nature" },
  { name: "火焰聲", path: "/audio/FireCrackles.m4a", category: "nature" },
  { name: "冰雪", path: "/audio/IcySnow.m4a", category: "nature" },
  { name: "森林", path: "/audio/Forest.m4a", category: "nature" },
  { name: "夜晚", path: "/audio/Night.m4a", category: "nature" },
  { name: "春天", path: "/audio/Spring.m4a", category: "nature" },
  { name: "晴天", path: "/audio/SunnyDay.m4a", category: "nature" },
  { name: "下午", path: "/audio/Afternoon.m4a", category: "nature" },
  { name: "暴風雨", path: "/audio/Storm.m4a", category: "nature" },
  
  // 環境聲音
  { name: "城市", path: "/audio/City.m4a", category: "ambient" },
  { name: "城市環境", path: "/audio/CityAmbience.m4a", category: "ambient" },
  { name: "人群", path: "/audio/Crowd.m4a", category: "ambient" },
  { name: "遠處火車", path: "/audio/DistantTrain.m4a", category: "ambient" },
  { name: "火車", path: "/audio/Train.m4a", category: "ambient" },
  { name: "高速公路", path: "/audio/Highway.m4a", category: "ambient" },
  { name: "卡車引擎", path: "/audio/TruckEngine.m4a", category: "ambient" },
  { name: "噴水池", path: "/audio/Fountain.m4a", category: "ambient" },
  { name: "灑水器", path: "/audio/Sprinkler.m4a", category: "ambient" },
  { name: "鍵盤", path: "/audio/Keyboard.m4a", category: "ambient" },
  { name: "吹風機", path: "/audio/HairDryer.m4a", category: "ambient" },
  { name: "烘乾機", path: "/audio/Dryer.m4a", category: "ambient" },
  { name: "吸塵器", path: "/audio/Vacuum.m4a", category: "ambient" },
  { name: "電風扇", path: "/audio/OscillatingFan.m4a", category: "ambient" },
  { name: "心跳", path: "/audio/HeartBeat.m4a", category: "ambient" },
  { name: "貓咪呼嚕", path: "/audio/CatPurring.m4a", category: "ambient" },
  { name: "鐘聲", path: "/audio/GrandfatherClock.m4a", category: "ambient" },
  { name: "洞穴", path: "/audio/Cavern.m4a", category: "ambient" },
  { name: "水下", path: "/audio/Underwater.m4a", category: "ambient" },
  { name: "子宮", path: "/audio/Womb.m4a", category: "ambient" },
  { name: "遊樂場", path: "/audio/Playground.m4a", category: "ambient" },
  { name: "航行", path: "/audio/Sailing.m4a", category: "ambient" },
  { name: "冷響", path: "/audio/ColdRattle.m4a", category: "ambient" },
  { name: "霧角", path: "/audio/FogHorn.m4a", category: "ambient" },
  { name: "嘰嘰聲", path: "/audio/Chirp.m4a", category: "ambient" },
  { name: "聲音", path: "/audio/Voices.m4a", category: "ambient" },
  { name: "嗡嗡聲", path: "/audio/Humming.m4a", category: "ambient" },
  
  // 音樂
  { name: "抽象", path: "/audio/Abstract.m4a", category: "music" },
  { name: "星體", path: "/audio/Astral.m4a", category: "music" },
  { name: "巴厘霧", path: "/audio/BaliMist.m4a", category: "music" },
  { name: "低音樂", path: "/audio/BassMusic.m4a", category: "music" },
  { name: "布拉姆斯搖籃曲", path: "/audio/BrahmsLullaby.m4a", category: "music" },
  { name: "蝴蝶", path: "/audio/Butterfly.m4a", category: "music" },
  { name: "嘉年華", path: "/audio/Carnival.m4a", category: "music" },
  { name: "合唱", path: "/audio/Choir.m4a", category: "music" },
  { name: "戲劇性", path: "/audio/Dramatic.m4a", category: "music" },
  { name: "夢境", path: "/audio/Dreams.m4a", category: "music" },
  { name: "鼓", path: "/audio/Drum.m4a", category: "music" },
  { name: "杜德克", path: "/audio/Duduk.m4a", category: "music" },
  { name: "地球戲劇", path: "/audio/EarthDrama.m4a", category: "music" },
  { name: "永恆", path: "/audio/Eternity.m4a", category: "music" },
  { name: "長笛", path: "/audio/Flute.m4a", category: "music" },
  { name: "長笛 2", path: "/audio/Flute2.m4a", category: "music" },
  { name: "吉他", path: "/audio/Guitar.m4a", category: "music" },
  { name: "和諧", path: "/audio/Harmony.m4a", category: "music" },
  { name: "沉浸", path: "/audio/Immersed.m4a", category: "music" },
  { name: "印度", path: "/audio/India.m4a", category: "music" },
  { name: "印度鼓", path: "/audio/IndianDrums.m4a", category: "music" },
  { name: "喜悅", path: "/audio/Joy.m4a", category: "music" },
  { name: "木星", path: "/audio/Jupiter.m4a", category: "music" },
  { name: "休閒", path: "/audio/Lounge.m4a", category: "music" },
  { name: "魔法風鈴", path: "/audio/MagicChimes.m4a", category: "music" },
  { name: "中世紀", path: "/audio/Medieval.m4a", category: "music" },
  { name: "旋律", path: "/audio/Melody.m4a", category: "music" },
  { name: "僧侶吟唱", path: "/audio/MonkChant.m4a", category: "music" },
  { name: "音樂盒", path: "/audio/MusicBox.m4a", category: "music" },
  { name: "管弦樂", path: "/audio/Orchestral.m4a", category: "music" },
  { name: "帕海貝爾卡農", path: "/audio/PachelbelCanon.m4a", category: "music" },
  { name: "鋼琴", path: "/audio/Piano.m4a", category: "music" },
  { name: "歌唱碗", path: "/audio/SingingBowl.m4a", category: "music" },
  { name: "慢波", path: "/audio/SlowWaves.m4a", category: "music" },
  { name: "甜蜜祈禱時刻", path: "/audio/SweetHourPrayer.m4a", category: "music" },
  { name: "西藏碗", path: "/audio/TibetanBowls.m4a", category: "music" },
  { name: "托斯卡納", path: "/audio/Toskana.m4a", category: "music" },
  { name: "部落", path: "/audio/Tribal.m4a", category: "music" },
  { name: "觀看", path: "/audio/Watching.m4a", category: "music" },
  { name: "禪", path: "/audio/Zen.m4a", category: "music" },
  { name: "祖先", path: "/audio/Ancestral.m4a", category: "music" },
  { name: "唵", path: "/audio/Om.m4a", category: "music" },
  
  // 雙耳節拍
  { name: "雙耳節拍 2.5 Hz", path: "/audio/Binaural2.5hz.m4a", category: "binaural" },
  { name: "雙耳節拍 4 Hz", path: "/audio/Binaural4hz.m4a", category: "binaural" },
  { name: "雙耳節拍 5 Hz", path: "/audio/Binaural5hz.m4a", category: "binaural" },
  { name: "雙耳節拍 8 Hz", path: "/audio/Binaural8hz.m4a", category: "binaural" },
  { name: "雙耳節拍 10 Hz", path: "/audio/Binaural10hz.m4a", category: "binaural" },
  { name: "雙耳節拍 20 Hz", path: "/audio/Binaural20hz.m4a", category: "binaural" },
  
  // 等時節拍
  { name: "等時節拍 2.5 Hz", path: "/audio/Isochronic2.5hz.m4a", category: "isochronic" },
  { name: "等時節拍 4 Hz", path: "/audio/Isochronic4hz.m4a", category: "isochronic" },
  { name: "等時節拍 5 Hz", path: "/audio/Isochronic5hz.m4a", category: "isochronic" },
  { name: "等時節拍 8 Hz", path: "/audio/Isochronic8hz.m4a", category: "isochronic" },
  { name: "等時節拍 10 Hz", path: "/audio/Isochronic10hz.m4a", category: "isochronic" },
  { name: "等時節拍 20 Hz", path: "/audio/Isochronic20hz.m4a", category: "isochronic" }
];